import * as React from 'react';
import Grid from '@mui/material/Grid';


import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';

import Link from '@mui/material/Link';
import Button from '@mui/material/Button';

const ModalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    maxWidth: '900px',
    display: 'block',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: "1.5rem",
    '::-webkit-scrollbar': { width: 0, height: 0 }
};

function getDisplayAddress(user_address, user_ens){
    if (user_ens) {
        return user_ens
    }
    return user_address
}

class CallToActionModal extends React.Component<any, any> {

    render() {
        return <Modal open={this.props.open} onClose={this.props.onClose}>
        <Paper elevation={3} sx={ModalStyle} style={{overflowX:"hidden", overflowY:"scroll", scrollbarWidth:"none"}}>
            <Grid container spacing={2} >
            <Grid item xs={11} sx={{textAlign:"center"}}>
                <Typography id="modal-modal-title" variant="h4" component="h2">
                    {getDisplayAddress(this.props.user_address, this.props.user_ens)} does not own any of our Digital Certificates!
                </Typography>
            </Grid>
            <Grid item xs={12}>
                Head over to {" "}
                <Link href="https://opensea.io/collection/bloomeria-nftrees-rmterra-anceriz-collection" target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                OpenSea to buy one of our Digital Certicates !
                </Link>
                <p>
                    Take a look at our  {" "}
                    <Link href="https://bloomeria.org/rmterra/" target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                    partnership with RMTerra
                </Link> 
                    {" "} to get a better understanding of what our Digital Certificates represent.
                </p>
                <Button variant="contained" href="https://opensea.io/collection/bloomeria-nftrees-rmterra-anceriz-collection" target="_blank" sx={{margin: "0 auto", display:"block", width:"220px", padding:"6px"}}>Buy a Digital Certificate!</Button>
            </Grid>
          </Grid>
        </Paper>
          
      </Modal>
        
    }
}

export default CallToActionModal